import { DailyShare } from "../../../Interfaces/FundraiserRole";
import { daysToSymbols } from "../../../constants";
import "./ShareStreak.css";

interface ShareStreakProps {
  streak: DailyShare;
}

const ShareStreak: React.FC<ShareStreakProps> = ({ streak }) => {
  const streakDays = streak.streak_days;
  const streakCount = streak.streak_count;

  return (
    <div className="share-streak-container">
      <div className="share-streak-top-row">
        <div className="share-streak-left-display">
          <div>{streakCount}</div>
          <p>Day Sharing Streak</p>
        </div>
        <div className="share-streak-right-display">🔥</div>
      </div>
      <p className="share-streak-display-text">
        Share today to keep your streak alive.{" "}
        {/*and unlock the 7-day badge! //removing until badges are implemented*/}
      </p>
      <div className="share-streak-days">
        {Object.entries(streakDays).map(([dayName, isActive], index) => (
          <button
            key={index}
            className={`share-streak-day ${isActive ? "active" : ""}`}
          >
            {daysToSymbols[dayName]}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ShareStreak;
